import type { UtilityContext } from '@change-corgi/core-react/utilityContext';

import type {
	StarterDashboardV2ContactDmConfigQuery,
	StarterDashboardV2ContactDmConfigQueryVariables,
} from './getStarterContactDmConfig.graphql';
import { StarterDashboardV2ContactDmConfig } from './getStarterContactDmConfig.graphql';

export async function getStarterContactDmConfig(utilityContext: UtilityContext) {
	const {
		data: {
			featureConfigs: { starterDashboardContactDm },
		},
	} = await utilityContext.gql.fetch<
		StarterDashboardV2ContactDmConfigQuery,
		StarterDashboardV2ContactDmConfigQueryVariables
	>({
		query: StarterDashboardV2ContactDmConfig,
		rejectOnError: true,
	});

	return {
		emailEnabled: !!starterDashboardContactDm?.emailEnabled,
	};
}
